import { ELanguage, JobCardMini, Utils } from '@microfrontends/react-components'
import React, { useCallback, useContext } from 'react'
import AppContext from '../../../../context/AppContext'
import generateLinkJob from '../../../../helpers/generateLinkJob'
import { TJob } from '../../../CareerPath/Detail/types'
import { decrypt } from '../../../../services/auth/cryptor'
import { EDevice } from '../../../../containers/MainLayout'
import { initialDataProvider, useInitialData } from '@microfrontends/app-shell-v2'

interface IProps {
	job: TJob
	isFinalIndex: boolean
	utm?: string
}

const JobCard: React.FC<IProps> = ({
	job,
	isFinalIndex,
	utm = 'utm_source_navi=empower-growth&utm_medium_navi=job-will-love&utm_campaign_navi=home&utm_content_navi=SmartNaviIOP'
}) => {
	const { languageCode, user, breakpoint } = useContext(AppContext)
	const initData = useInitialData(languageCode ?? ELanguage.VI)
	const token = decrypt(user?.accessToken || '')
	/*
	 * Handling action
	 * */
	const getJobUrl = useCallback(
		(job: any) => {
			return generateLinkJob(
				job.alias,
				job.jobId.toString(),
				languageCode || ELanguage.VI,
				utm
			)
		},
		[languageCode]
	)

	const companyAlias = Utils.slugify(job?.companyName || '')

	let companyUrl = `/${
		languageCode === ELanguage.EN ? 'companies' : 'nha-tuyen-dung'
	}/${companyAlias}-c${job?.companyId}`
	if (job?.isAnonymous) {
		companyUrl = ''
	}
	const userInfo = {
		...user,
		jobLevelId: (user?.jobLevelId && user?.jobLevelId[0]) ?? 0
	}
	const locationText = job.workingLocations
		? job.workingLocations
				.map((location) =>
					languageCode === ELanguage.EN
						? location.cityName
						: location.cityNameVI
				)
				.join(', ')
		: ''
	return (
		<JobCardMini
			item={{
				jobTitle: job.jobTitle,
				jobId: job.jobId,
				jobUrl: getJobUrl(job),
				companyLogo: job.companyLogo,
				company: job.companyName,
				companyUrl: companyUrl,
				address: job.address,
				jobDescription: job.jobDescription,
				jobLevelId: job.jobLevelId,
				jobRequirement: job.jobRequirement,
				isSaved: job.isSaved,
				isApplied: job.isApplied,
				isBlackList: job.isBlackList,
				redirectTo: job.redirectTo,
				locationText,
				jobLevelText:
					languageCode === ELanguage.VI
						? job.jobLevelVI
						: job.jobLevel,
				prettySalary: job.prettySalary,
				isAnonymous: job.isAnonymous,
				jobInvitation: job.jobInvitation ?? { jobInvitationId: 0, status: 0 }
			}}
			langCode={languageCode || ELanguage.VI}
			isMobile={breakpoint === EDevice.MOBILE}
			api={{
				baseUrl: process.env.API_DOMAIN || '',
				accessToken: token,
				appId: process.env.VNW_APP_ID || '',
				source: 'Numerology'
			}}
			previewJob={{
				enable: breakpoint !== EDevice.MOBILE,
				appMode: 'production',
				baseUrl: process.env.VNW_BASE_URL || ''
			}}
			settingJob={{
				showType: isFinalIndex ? 'top' : 'bottom'
			}}
			userInfo={userInfo as any}
			initData={initData}
		/>
	)
}

export default JobCard
